// extracted by mini-css-extract-plugin
export default {"button":"AnswerScore_button__IKj9c","noScore":"AnswerScore_noScore__nFLMl","changeScore":"AnswerScore_changeScore__H72Yu","inputNumber":"AnswerScore_inputNumber__3gxYe"};